const features = [
  {
    icon: 'ri-book-open-line',
    title: '海量漫画资源',
    desc: '收录5000+热门日漫、韩漫、国漫大全，涵盖恋爱、热血、奇幻、悬疑等多种题材。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '下拉式全集阅读',
    desc: '支持纵向连续下拉阅读模式，自动加载下一话，无需翻页畅快追更完整漫画。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '每日同步更新',
    desc: '与日韩官方同步更新热门连载，第一时间追更最新话，永不错过精彩剧情。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '永久免费畅看',
    desc: '无需注册登录，无需付费订阅，歪歪漫画免费入口直接在线观看全部漫画内容。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '智能分类检索',
    desc: '按题材、地区、热度、更新状态等多维度筛选，快速找到你想看的好看漫画。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">本站特色</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">为什么数百万漫画爱好者选择歪歪漫画网？五大核心优势为您揭晓</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="bg-background-50 rounded-lg p-5 md:p-6 text-center group hover:bg-primary-50 transition-colors cursor-default"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${feat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}